import { Boxes, type LucideIcon, Workflow } from "lucide-react";

/**
 * The icon each submit action carries, wherever it is offered: the project
 * page's `SubmitChoices` cards and the Dashboard header's buttons
 * (fs#2000). One map, so the two surfaces can never show different icons.
 */
export const SUBMIT_ICONS: Readonly<Record<"tile" | "flow", LucideIcon>> = {
  tile: Boxes,
  flow: Workflow,
};
